import React from "react";
import logo from '../../assets/logo2.svg';

interface HeaderProps {
    onToggleSidebar?: () => void;
}

const Header: React.FC<HeaderProps> = ({ onToggleSidebar }) => {
    const adminEmail = sessionStorage.getItem('adminEmail') || 'admin@penpal.com';
    const adminName = adminEmail.split('@')[0].toUpperCase();

    return (
        <>
            <header className="nxl-header">
                <div className="header-wrapper">
                    <div className="header-left d-flex align-items-center">
                        <a
                            href="javascript:void(0);"
                            id="mobile-collapse"
                            className="nxl-head-link"
                            onClick={(e) => { e.preventDefault(); onToggleSidebar?.(); }}
                        >
                            <i className="feather-menu" style={{ fontSize: 22 }}></i>
                        </a>
                    </div>

                    <div className="header-right ms-auto">
                        <div className="d-flex align-items-center">

                            <div className="dropdown nxl-h-item">
                                <a href="javascript:void(0);" data-bs-toggle="dropdown" role="button"
                                    data-bs-auto-close="outside">
                                    <img src={logo} alt="user-image"
                                        className="img-fluid user-avtar me-0" />
                                </a>
                                <div className="dropdown-menu dropdown-menu-end nxl-h-dropdown nxl-user-dropdown">
                                    <div className="dropdown-header">
                                        <div className="d-flex align-items-center">
                                            <img src={logo} alt="user-image"
                                                className="img-fluid user-avtar" />
                                            <div>
                                                <h6 className="text-dark mb-0">{adminName} <span
                                                    className="badge bg-soft-success text-success ms-1">ADMIN</span></h6>
                                                <span
                                                    className="fs-12 fw-medium text-muted">{adminEmail}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="dropdown-divider"></div>
                                    <a href="javascript:void(0);" className="dropdown-item" onClick={(e) => {
                                        e.preventDefault();
                                        sessionStorage.removeItem('adminToken');
                                        sessionStorage.removeItem('adminEmail');
                                        window.location.href = '/adminLogin';
                                    }}>
                                        <i className="feather-log-out"></i>
                                        <span>Logout</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

        </>
    )
}

export default Header;
